import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { createInstance } from '../../utils/dynamic-items-utils';
import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';

export function presetSelectHeader(): IDynamicItem {
  const headerText = createInstance({
    id: 'preselect-header-select',
    contentTypeId: 'dynamic-elements-filter-select',
    data: {
      options: [
        {
          name: '0',
          displayName:
            recommendationsPanelsLocaleKeys.mostFrequentlyOrderedOption,
        },
        {
          name: '1',
          displayName: recommendationsPanelsLocaleKeys.mostBoughtOption,
        },
      ],
    },
    inputs: {
      filterItem: {
        provider: 'self',
        property: 'options',
        transform: function (options: any) {
          return {
            isSingle: true,
            values: options,
          };
        }.toString(),
      },
      activeValues: {
        provider: 'id:root',
        property: 'selectedHeaderPreset',
        startWith: ['0'],
        transform: function ($event: any) {
          return window.neoclesDynamicFramework.recommendationsPanels.methods.isNonNullish(
            $event,
          )
            ? $event
            : ['0'];
        }.toString(),
      },
      allowShowAll: false,
      selectedValuesAsLabel: true,
      selectSingleValueByDefault: true,
      dropdownButtonClass: {
        provider: 'id:root',
        property: 'filterSelectVariables',
      },
      labelAppend: {
        provider: 'GlobalStoreProviderService',
        property: {
          paths: 'user.current',
        },
        transform: function (user: { displayName: string }) {
          return `, ${user.displayName?.split(' ')[0]}`;
        }.toString(),
      },
    },
    styles: {
      dynamicVariables: {
        provider: 'id:root',
        property: 'headerVariables',
      },
    },
  });

  const popoverWrapper = createInstance({
    id: 'header-select-wrapper',
    contentTypeId: 'dynamic-elements-popover-wrapper',
    if: [
      'EQ',
      [
        {
          provider: 'id:root',
          property: 'hasPresetSelectHeader',
        },
        true,
      ],
    ],
    data: {
      mostFrequentlyOrderedOptionDescription:
        recommendationsPanelsLocaleKeys.mostFrequentlyOrderedOptionDescription,
      mostBoughtOptionDescription:
        recommendationsPanelsLocaleKeys.mostBoughtOptionDescription,
    },
    inputs: {
      triggers: 'hover',
      triggerContent: headerText,
      popoverContent: {
        contentTypeId: 'dynamic-elements-simple-text',
        inputs: {
          autoClose: false,
          text: {
            values: [
              {
                provider: 'id:root',
                property: 'hasPresetSelectHeader',
              },
              {
                provider: 'id:preselect-header-select',
                property: 'toggleFilter',
                startWith: ['0'],
              },
              {
                provider: 'id:header-select-wrapper',
                property: 'mostFrequentlyOrderedOptionDescription',
              },

              {
                provider: 'id:header-select-wrapper',
                property: 'mostBoughtOptionDescription',
              },
            ],
            transform: function ([
              hasPresetSelectHeader,
              selectedHeaderPreset,
              mostFrequentlyOrderedOptionDescription,
              mostBoughtOptionDescription,
            ]: [boolean, string, string, string]) {
              if (hasPresetSelectHeader && selectedHeaderPreset?.[0] === '1') {
                return mostFrequentlyOrderedOptionDescription;
              }
              return mostBoughtOptionDescription;
            }.toString(),
          },
        },
        styles: {
          classes: ['popover-arrow-down'],
          style: {
            background: '#000',
            color: '#fff',
          },
        },
      },
      popoverPlacement: 'top',
      panelClass: 'header-select-wrapper-panel',
      componentClass: 'header-select-wrapper-component',
    },
    styles: {
      style: {
        __multiple__: {
          provider: 'id:root',
          property: 'headerStyle',
        },
      },
      css: `
        .header-select-wrapper-component {--popover-bg: #000; padding: 4px 8px;}
        .header-select-wrapper-panel {margin-bottom: 10px;}
      `,
    },
  });

  return popoverWrapper;
}
